<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    {{text.announcementList}}
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">{{text.docs}}</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="'' !== errorMessage"> {{ errorMessage }} </alert-fail>
                    <b-row>
                      <b-col cols="2" md="1">
                          <b-form-group
                          :label="text.filter"
                          >
                          </b-form-group>
                      </b-col>
                      <b-col cols="7" md="8" class="magin-minus-top-5">
                          <v-select :clearable="false" v-model="filter.project" :options="projectList" :placeholder="'filter project'"></v-select>
                      </b-col>
                      <b-col cols="3" md="3" class="magin-minus-top-5">
                          <v-select :clearable="false" v-model="filter.type" class="users-filter" :options="['all', 'announcement', 'activity']" :placeholder="'filter type'"></v-select>
                      </b-col>
                    </b-row>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="currentPage"
                          :per-page="numberPerPage"
                          class="table-privilege"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectedVariant="single"
                          selectable
                          :fields="fields"
                          :items="list">
                          <template slot="thumbnail" slot-scope="row">
                            <img class="thumbnail" :src="row.item.thumbnail" alt="Thumbnail">
                          </template>
                          <template slot="active" slot-scope="row">
                              <font style="color: #f86c6b" v-if="row.item.active">Inactive</font>
                              <font style="color: #4dbd74" v-else>Active</font>
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                        <b-pagination
                        class="pagination my-0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="numberPerPage"
                        ></b-pagination>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import AlertFail from '../../../components/alert/AlertFail';
import { dateToStringWithTimeFull } from '../../../assets/utils/time';
import vSelect from 'vue-select';
import { ProjectList } from '../../../models/project-list';
import { textAnnouncement } from '../../../assets/utils/language';

export default {
  data () {
    return {
      errorMessage: '',
      isBusy: false,
      currentPage: 1,
      numberPerPage: 20,
      fields: [],
      list: [
        // { thumbnail: '/images/101/thumbnail.png', createdDate: '10 September 2019, 23:27:48', type: 'announcement', topic: 'GULF คือหุ้นอะไรครับ ยิ่งแช่งยิ่งขึ้น GULF คือหุ้นอะไรครับ ยิ่งแช่งยิ่งขึ้น GULF คือหุ้นอะไรครับ ยิ่งแช่งยิ่งขึ้น' }
      ],
      filter: {
        project: '',
        type: 'all'
      },
      delay: { time: 1000, interval: null },
      projectList: [],
      text: {}
    };
  },
  methods: {
    viewDetails (e) {
      this.$router.push({ name: 'announcement-details', params: { id: e.id } });
    },
    getData () {
      const projectCode = null === this.filter.project ? this.projectList[0].code : this.filter.project.code ? this.filter.project.code : this.projectList[0].code;
      this.list = [];
      this.axios.get(process.env.VUE_APP_URL_MESSAGING_API + `/announcement?project=${'ALL' === projectCode ? '' : projectCode}&type=${'all' === this.filter.type ? '' : this.filter.type}`)
        .then(response => {
          const data = response.data.data;
          if (data) {
            data.announcements.forEach(announcement => {
              this.list.push({
                id: announcement.id,
                thumbnail: announcement.thumbnail || '/images/oneapp/thumbnail.jpg',
                createdDate: dateToStringWithTimeFull(new Date(announcement.createdAt.utc)),
                type: announcement.type,
                topic: announcement.topic,
                publish: announcement.isPublish ? 'yes' : 'no'
              });
            });
          }
        })
        .catch(error => {
          this.errorMessage = error.response ? error.response.data : error.message;
        })
        .finally(() => {
          this.isBusy = false;
        });
    }
  },
  computed: {
    totalRows () {
      return this.list.length;
    }
  },
  components: {
    AlertFail,
    'v-select': vSelect
  },
  watch: {
    'filter.project' () {
      if (this.delay.time < 1000) {
        this.delay.time = 1000;
      }
      if (null === this.delay.interval) {
        this.delay.interval = setInterval(() => {
          this.delay.time = this.delay.time - 200;
          if (0 === this.delay.time) {
            clearInterval(this.delay.interval);
            this.delay.interval = null;
            this.getData();
          }
        }, 100);
      }
    },
    'filter.type' () {
      this.getData();
    },
    $language: function () {
      this.text = textAnnouncement(this.$language);
      this.fields = [
        { key: 'thumbnail', label: this.text.thumbnail },
        { key: 'createdDate', label: this.text.createdDate },
        { key: 'type', label: this.text.type },
        { key: 'topic', label: this.text.topic },
        { key: 'publish', label: this.text.publish }
      ];
    }
  },
  mounted () {
    this.text = textAnnouncement(this.$language);
    this.fields = [
      { key: 'thumbnail', label: this.text.thumbnail },
      { key: 'createdDate', label: this.text.createdDate },
      { key: 'type', label: this.text.type },
      { key: 'topic', label: this.text.topic },
      { key: 'publish', label: this.text.publish }
    ];
    this.projectList = (new ProjectList()).getProjectFilter();
    if (this.projectList.length > 0) {
      this.filter.project = this.projectList[0];
    }
  }
};
</script>

<style scoped>
  .thumbnail{
        max-width: 100px;
    }
  .magin-minus-top-5{
      margin-top: -5px
  }
</style>
<style>
    .pagination {
        margin-left: auto;
        margin-right: auto;
    }
    .users-filter .vs__search::placeholder,
    .users-filter .vs__dropdown-toggle,
    .users-filter .vs__dropdown-menu {
        color: #394066;
        font-variant: small-caps;
        border: 1px solid #e4e7ea;
    }
    .filter-status {
        margin-top: 1px;
    }
</style>
